import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export const KNOWBE4_REGIONS = ['US', 'EU', 'CA', 'UK', 'DE'] as const;

export type KnowBe4Region = (typeof KNOWBE4_REGIONS)[number];

export type Knowbe4ConnectorConfig = typeof Knowbe4Connector._.Config;

export const Knowbe4Connector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Knowbe4,
  logoPath: 'images/knowbe4-logo.svg',
  categories: [IntegrationConnectorCategory.Security],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.ApiToken,
      configSchema: z.object({
        region: z.enum(KNOWBE4_REGIONS),
      }),
      encryptedConfigSchema: z.object({
        apiToken: z.string().trim().min(1),
      }),
    }),
  ]),
});
